
/**
 * 国省列表
*/

export const cityList = [
	{
		value: '中国',
		label: '中国',
		children: [
			{
				label: "北京市", value: "北京市"
			},
			{
				label: "天津市", value: "天津市"
			},
			{
				label: "河北省", value: "河北省"
			},
			{
				label: "山西省", value: "山西省"
			},
			{
				label: "内蒙古自治区", value: "内蒙古自治区"
			},
			{
				label: "辽宁省", value: "辽宁省"
			},
			{
				label: "吉林省", value: "吉林省"
			},
			{
				label: "黑龙江省", value: "黑龙江省"
			},
			{
				label: "上海市", value: "上海市"
			},
			{
				label: "江苏省", value: "江苏省"
			},
			{
				label: "浙江省", value: "浙江省"
			},
			{
				label: "安徽省", value: "安徽省"
			},
			{
				label: "福建省", value: "福建省"
			},
			{
				label: "江西省", value: "江西省"
			},
			{
				label: "山东省", value: "山东省"
			},
			{
				label: "河南省", value: "河南省"
			},
			{
				label: "湖北省", value: "湖北省"
			},
			{
				label: "湖南省", value: "湖南省"
			},
			{
				label: "广东省", value: "广东省"
			},
			{
				label: "广西壮族自治区", value: "广西壮族自治区"
			},
			{
				label: "海南省", value: "海南省"
			},
			{
				label: "重庆市", value: "重庆市"
			},
			{
				label: "四川省", value: "四川省"
			},
			{
				label: "贵州省", value: "贵州省"
			},
			{
				label: "云南省", value: "云南省"
			},
			{
				label: "西藏自治区", value: "西藏自治区"
			},
			{
				label: "陕西省", value: "陕西省"
			},
			{
				label: "甘肃省", value: "甘肃省"
			},
			{
				label: "青海省", value: "青海省"
			},
			{
				label: "宁夏回族自治区", value: "宁夏回族自治区"
			},
			{
				label: "新疆维吾尔自治区", value: "新疆维吾尔自治区"
			},
			{
				label: "台湾省", value: "台湾省"
			},
			{
				label: "香港特别行政区", value: "香港特别行政区"
			},
			{
				label: "澳门特别行政区", value: "澳门特别行政区"
			}
		]
	},
	{
		value: '日本',
		label: '日本',
		children: [
			{
				label: "北海道", value: "北海道"
			},
			{
				label: "青森県", value: "青森県"
			},
			{
				label: "岩手県", value: "岩手県"
			},
			{
				label: "宮城県", value: "宮城県"
			},
			{
				label: "秋田県", value: "秋田県"
			},
			{
				label: "山形県", value: "山形県"
			},
			{
				label: "福島県", value: "福島県"
			},
			{
				label: "茨城県", value: "茨城県"
			},
			{
				label: "栃木県", value: "栃木県"
			},
			{
				label: "群馬県", value: "群馬県"
			},
			{
				label: "埼玉県", value: "埼玉県"
			},
			{
				label: "千葉県", value: "千葉県"
			},
			{
				label: "東京都", value: "東京都"
			},
			{
				label: "神奈川県", value: "神奈川県"
			},
			{
				label: "新潟県", value: "新潟県"
			},
			{
				label: "富山県", value: "富山県"
			},
			{
				label: "石川県", value: "石川県"
			},
			{
				label: "福井県", value: "福井県"
			},
			{
				label: "山梨県", value: "山梨県"
			},
			{
				label: "長野県", value: "長野県"
			},
			{
				label: "岐阜県", value: "岐阜県"
			},
			{
				label: "静岡県", value: "静岡県"
			},
			{
				label: "愛知県", value: "愛知県"
			},
			{
				label: "三重県", value: "三重県"
			},
			{
				label: "滋賀県", value: "滋賀県"
			},
			{
				label: "京都府", value: "京都府"
			},
			{
				label: "大阪府", value: "大阪府"
			},
			{
				label: "兵庫県", value: "兵庫県"
			},
			{
				label: "奈良県", value: "奈良県"
			},
			{
				label: "和歌山県", value: "和歌山県"
			},
			{
				label: "鳥取県", value: "鳥取県"
			},
			{
				label: "島根県", value: "島根県"
			},
			{
				label: "岡山県", value: "岡山県"
			},
			{
				label: "広島県", value: "広島県"
			},
			{
				label: "山口県", value: "山口県"
			},
			{
				label: "徳島県", value: "徳島県"
			},
			{
				label: "香川県", value: "香川県"
			},
			{
				label: "愛媛県", value: "愛媛県"
			},
			{
				label: "高知県", value: "高知県"
			},
			{
				label: "福岡県", value: "福岡県"
			},
			{
				label: "佐賀県", value: "佐賀県"
			},
			{
				label: "長崎県", value: "長崎県"
			},
			{
				label: "熊本県", value: "熊本県"
			},
			{
				label: "大分県", value: "大分県"
			},
			{
				label: "宮崎県", value: "宮崎県"
			},
			{
				label: "鹿児島県", value: "鹿児島県"
			},
			{
				label: "沖縄県", value: "沖縄県"
			}
		]
	},

]
